import React, { useContext, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

import { GlobalContext } from './contexts/global.context';

import Header from './components/header/header.component';
import Nav from './components/nav/nav.component';
import Footer from './components/footer/footer.component';
import Map from './components/map/map.component';
import Charts from './components/charts/charts.component';
import OptionsPanel from './components/options-panel/options-panel.component';
import Loading from './components/loading/loading.component';
import Legend from './components/legend/legend.component';
import TextPanel from './components/text-panel/text-panel.component';
import TextBlock from './components/text-block/text-block.component';
import Home from './components/home/home.component';
import About from './components/about/about.component';
import ErrorDisplay from './components/error-display/error-display.component';
import PDFPanel from './components/pdf-panel/pdf-panel.component';
import BiomassText from './components/biomassText/biomassText.component';

import { useScrollWithShadow } from './hooks/useScrollWithShadow';

import './App.scss';

ReactGA.initialize('G-56V5Y7C69Y');

function App() {
  const { display, isLoading, error, setError, selectedTab, selectedSubTab, loading } = useContext(GlobalContext);
  const { boxShadow, onScrollHandler } = useScrollWithShadow();
  const location = useLocation();

  // Send analytics data to Google
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
    <div className='App'>
      <div style={{ position: 'relative', zIndex: 2 }}>
        <Header />
        <Nav />
      </div>

      <div onScroll={onScrollHandler} style={{ position: 'relative', zIndex: 1, overflowY: 'auto' }}>
        <main>
          {selectedTab === 'Home' ?
            <Home />
            :
            (selectedTab === 'About' ?
              <About />
              :
              selectedSubTab === 'Heterobasidion Root Disease' ? (
                <React.Fragment>
                  <div style={{ minHeight: 'calc(100vh - 230px)', display: 'flex', flexDirection: 'column' }}>
                    <h2>Heterobasidion Root Disease</h2>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                      <p style={{ textAlign: 'center', fontStyle: 'italic', fontSize: '24px', color: 'rgb(100,100,100)' }}>Coming soon...</p>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <TextBlock blockName={display === 'chart' ? 'aboveChartsTextBlock' : 'aboveMapsTextBlock'} />

                  <div className='map-content-container'>
                    <OptionsPanel />
                    <div className='main-panel'>
                      <Map />
                      <Legend />
                      {display === 'chart' && <Charts />}
                    </div>
                  </div>

                  <BiomassText />

                  <div className="text-block">
                    <TextPanel />
                  </div>
                  <PDFPanel />
                </React.Fragment>
              )
            )
          }
          {
            isLoading && 
            (
              (selectedTab !== 'Home' && selectedTab !== 'About') || 
              (
                !loading.includes('initialize') &&
                !loading.includes('getBaseData')
              )
            ) && <Loading />
          }
        </main>
        
        <Footer />

        <div className='nav-shadow' style={{ boxShadow }}></div>
      </div>

      {error.error === null ? '' :
        <ErrorDisplay error={error} setError={setError} iconBtnStyles={{
          position: 'absolute',
          top: '12px',
          left: '12px'
        }}/>
      }
    </div>
  );
}

export default App;